import {
  ARTIST,
  AWARD,
  FAQ,
  MEDIA,
  NEWS,
  PARTNER,
  PROJECT,
  WEBINAR,
} from "@constants/routes";

const SECTIONS = [
  { route: ARTIST, name: "Artists" },
  { route: AWARD, name: "Awards" },
  { route: FAQ, name: "FAQs" },
  { route: MEDIA, name: "Media" },
  { route: NEWS, name: "News" },
  { route: PARTNER, name: "Partners" },
  { route: PROJECT, name: "Projects" },
  { route: WEBINAR, name: "Webinars" },
];

export default SECTIONS;
